// Webpack Imports
import * as bootstrap from "bootstrap";

(function () {
  "use strict";

  // Focus input if Searchform is empty
  [].forEach.call(document.querySelectorAll(".search-form"), (el) => {
    el.addEventListener("submit", function (e) {
      var search = el.querySelector("input");
      if (search.value.length < 1) {
        e.preventDefault();
        search.focus();
      }
    });
  });

  // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
  var popoverTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="popover"]')
  );
  var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl, {
      trigger: "focus",
    });
  });
})();

// dodaje selektor do otwartego navbara
(function ($) {
  $(document).on("click", ".navbar-toggler", function () {
    $(this).parents(".navbar").toggleClass("nav-opened");
    //   $(".navbar").toggleClass("nav-opened");
  });
})(jQuery);

(function ($) {
  $(".js-anchor, .js-nav-top li a").on("click", function (event) {
    let type = $(this).attr("href").split("#")[1];
    if ($("#" + type).length) {
      event.preventDefault();
      if($(window).width() >= 992 ){
        $("html, body").animate(
          {
            scrollTop: $("#" + type).offset().top - 50,
          },
          500
        );
      }else{
        $("html, body").animate(
          {
            scrollTop: $("#" + type).offset().top - 350,
          },
          500
        );
      }
      $('.navbar-toggler').trigger('click');
    }
  });
})(jQuery);

(function ($, root, undefined) {
  $(function () {
    // 'use strict';

    AOS.init({
      offset: 200,
      duration: 500,
      // easing: 'ease-in-out',
      delay: 100,
      once: true,
    });
  });
})(jQuery, this);



// Uzupełnia klasy w formularzu CF7
(function ($) {
  if($('.wpcf7-form').length){
    var astx_label_class = 'form-check-label',
    astx_input_class = 'form-check-input',
    astx_parent_class = 'form-check form-check-inline';

    $('.wpcf7-form input[type=checkbox], .wpcf7-form input[type=radio]').each(function(){
      var element = $(this),
        parent = element.closest('.wpcf7-list-item');
      element.addClass(astx_input_class);
      parent.addClass(astx_parent_class);
      if(astx_label_class)
        parent.find('wpcf7-list-item-label').addClass(astx_label_class);
    });
  }
})(jQuery);

(function ($) {
  var scrollToTopBtn = document.getElementById("scrollToTopBtn");
  var rootElement = document.documentElement;
  function scrollToTop() {
    // Scroll to top logic
    rootElement.scrollTo({
      top: 0,
      behavior: "smooth"
    })
    };
  scrollToTopBtn.addEventListener("click", scrollToTop);
})(jQuery)